import { AppDownload } from './AppDownload';
import { EmailConfirmation } from './EmailConfirmation';
import { Login } from './Login';
import { ProductNotification } from './ProductNotification';

export default {
  AppDownload,
  EmailConfirmation,
  Login,
  ProductNotification
};
